// Frontend Firebase Functions SDK prefixes backend HttpsError codes with "functions/".
// ** IMPORTANT **: Keep shared values in sync with firebaseCallableErrorCode.tsx.
export enum EMAIL_CONVERSION_CALLABLE_ERROR_CODE {
    // Frontend-only conversion precheck failure code (non-callable path).
    precheckUnavailable = 'conversion/email-precheck-unavailable',
    alreadyExists = 'functions/already-exists',
    unavailable = 'functions/unavailable',
    invalidArgument = 'functions/invalid-argument',
    failedPrecondition = 'functions/failed-precondition',
    notFound = 'functions/not-found',
    unauthenticated = 'functions/unauthenticated',
}
